import RegisterTerms from './register-terms';

export default RegisterTerms;
